$(document).ready(function() {
	
	// LOADER FALLBACK - CLICK TO REMOVE
	$('#loader').click(function() {
		$(this).addClass('hidethis');
		setTimeout(function() {
			$(this).addClass('remove');
		},1000);
	});

});

// ON LOAD STUFF ============================== //
$(window).load(function() {
    
	// LOADER ============================== //
	$('#loader').addClass('hidethis');
	setTimeout(function() {
		$('#loader').addClass('remove');
	},1000);
	
	// CUSTOM PREVIEW ============================== //
	if($('#custom_preview').length != 0) {
		var thisSwatch 	= '';
		var colArray 	= ['black','coral','lemon','lime-green','orange','pastel-pink','pink','sea-green','sky-blue','thistle','white','mint','purple','sand','brown','teal','turquoise','light-grey','magenta','mango','tan','dark-grey'];
		var cordCol 	= '';
		var beadArray 	= [];
		
		$('.bold_option_value_element').mouseup(function() {												// Using mouseup as click conflicts with Bold script, I think!
			thisSwatch = $(this).closest('.bold_option_swatch').find('.bold_option_title').text(); 			// Find title of swatch we're working with.
			if (thisSwatch === 'Choose a Cord*') {
				cordCol = $(this).find('input[type="checkbox"]').attr('value').toLowerCase();
				cordCol = cordCol.replace(' ','-');
				if (colArray.indexOf(cordCol) > -1) {
					$('#custom_preview').addClass('reveal');
					$('#custom_preview .inner').attr('style','background-image: url(\'//cdn.shopify.com/s/files/1/0297/8971/6528/files/custom-bracelet-bg-' + cordCol + '.jpg?\');')
				}
			}
			if (thisSwatch === 'Choose Your Beads*') {
				$('#beads').removeClass('reveal');
				var thisBead = $(this).find('.bold_option_value_swatch span').css('background-image');
				thisBead = thisBead.replace('url(','').replace(')','').replace(/\"/gi, ""); 				// Strip out the path
				if (beadArray.indexOf(thisBead) < 0) {
					beadArray.push(thisBead);																// Add bead to array
					//console.log('BEAD IN - ' + beadArray.indexOf(thisBead));
					//console.log(beadArray);
				} else {
					beadArray.splice(beadArray.indexOf(thisBead),1);										// Remove bead from array
				}
				if (beadArray === 0){
					
				} else {
					$('#custom_preview').addClass('reveal');
					var beadImgs = '';
					$.each(beadArray,function(i,val){
						beadImgs += '<img src="' + val + '">';
					});
					setTimeout(function() {
					    $('#beads').html(beadImgs);
					}, 250);
					setTimeout(function() {
					    $('#beads').addClass('reveal');
					}, 750);
				}
			}
			if (thisSwatch === 'Toggle*') {
				$('#toggle').removeClass('reveal');
				var thisToggle = $(this).find('.bold_option_value_swatch span').css('background-image');
				//thisToggle = thisToggle.replace('url(','').replace(')','').replace(/\"/gi, ""); 				// Strip out the path
				$('#custom_preview').addClass('reveal');
				setTimeout(function() {
					$('#toggle').css('background-image', thisToggle);
				}, 250);
				setTimeout(function() {
				    $('#toggle').addClass('reveal');
				}, 750);
			}
	    });
    }
	    
	// COLOUR POP PREVIEW ============================== //
	if($('#colpop_preview').length != 0) {
		var thisSwatch 	= '';
		var pebCol 	    = '';
        var silkCol     = '';
		
		$('.bold_option_value_element').mouseup(function() {												// Using mouseup as click conflicts with Bold script, I think!
			thisSwatch = $(this).closest('.bold_option_swatch').find('.bold_option_title').text(); 			// Find title of swatch we're working with.
			if (thisSwatch === 'Choose your pebble colour*') {
				pebCol = $(this).find('input[type="checkbox"]').attr('value').toLowerCase();
				pebCol = pebCol.replace(/ /g,'-');
				//console.log(pebCol);
				$('#colpop_preview img').attr('src','//cdn.shopify.com/s/files/1/0297/8971/6528/files/cp-sg-' + pebCol + '.png');
			}
			if (thisSwatch === 'Choose your silk colour*') {
				silkCol = $(this).find('input[type="checkbox"]').attr('value').toLowerCase();
				silkCol = silkCol.replace(/ /g,'-');
				$('#colpop_preview').attr('style','background-image: url(\'//cdn.shopify.com/s/files/1/0297/8971/6528/files/cp-silk-' + silkCol + '.jpg\');');
			}
	    });
	    // Preload img to speed things up.
	    var sgArray 	= ['azure-blue','clockwork-orange','crocus-purple','lovebird-green','mermaid-jade','sea-mist-mint','sunshine-yellow','surfs-up-blue','unicorn-white','flamingo'];
	    $.each(sgArray,function(i,val){
			$('head').append('<link rel="preload" as="image" href="//cdn.shopify.com/s/files/1/0297/8971/6528/files/cp-sg-' + val + '.png">');
		});
	    var silkArray 	= ['black','blue','dark-green','grey','light-green','lilac','coral','pink','purple','red','turquoise','yellow'];
	    $.each(silkArray,function(i,val){
			$('head').append('<link rel="preload" as="image" href="//cdn.shopify.com/s/files/1/0297/8971/6528/files/cp-silk-' + val + '.jpg">');
		});
    }
	
	// COLOUR DROP PREVIEW ============================== //
	if($('#coldrop_preview').length != 0) {
		var thisSwatch 	= '';
		var dropCol 	= '';
        var silkCol     = '';
		
		$('.bold_option_value_element').mouseup(function() {												// Using mouseup as click conflicts with Bold script, I think!
			thisSwatch = $(this).closest('.bold_option_swatch').find('.bold_option_title').text(); 			// Find title of swatch we're working with.
			console.log(thisSwatch);
			for (var n = 1; n < 5; ++n) {
				if (thisSwatch === 'Choose Drop ' + n + '*') {
					dropCol = $(this).find('input[type="checkbox"]').attr('value').toLowerCase();
					dropCol = dropCol.replace(/ /g,'-');
					$('#coldrop_preview .img-' + n).attr('src','//cdn.shopify.com/s/files/1/0297/8971/6528/files/cd-' + dropCol + '-' + n + '.png?');
				}
			}
			if (thisSwatch === 'Choose your silk colour*') {
				silkCol = $(this).find('input[type="checkbox"]').attr('value').toLowerCase();
				silkCol = silkCol.replace(/ /g,'-');
				$('#coldrop_preview').attr('style','background-image: url(\'//cdn.shopify.com/s/files/1/0297/8971/6528/files/cp-silk-' + silkCol + '.jpg?\');');
			}
	    });
	    // Preload img to speed things up.
	    var sgArray 	= ['azure-blue','clockwork-orange','crocus-purple','lovebird-green','mermaid-jade','sea-mist-mint','sunshine-yellow','surfs-up-blue','unicorn-white','flamingo'];
	    $.each(sgArray,function(i,val){
			for (var n = 1; n < 5; ++n) {
				$('head').append('<link rel="preload" as="image" href="//cdn.shopify.com/s/files/1/0297/8971/6528/files/cd-' + val + '-' + n + '.png?">');
			}
		});
	    var silkArray 	= ['black','blue','dark-green','grey','light-green','lilac','coral','pink','purple','red','turquoise','yellow'];
	    $.each(silkArray,function(i,val){
			$('head').append('<link rel="preload" as="image" href="//cdn.shopify.com/s/files/1/0297/8971/6528/files/cp-silk-' + val + '.jpg?">');
		});
    }
	
	// COLOUR DROP SILVER PREVIEW ============================== //
	if($('#coldrop_silver_preview').length != 0) {
		var thisSwatch 	= '';
		var dropCol 	= '';
		$('.bold_option_value_element').mouseup(function() {												// Using mouseup as click conflicts with Bold script, I think!
			thisSwatch = $(this).closest('.bold_option_swatch').find('.bold_option_title').text(); 			// Find title of swatch we're working with.
			console.log(thisSwatch);
			for (var n = 1; n < 5; ++n) {
				if (thisSwatch === 'Choose Drop ' + n + '*') {
					dropCol = $(this).find('input[type="checkbox"]').attr('value').toLowerCase();
					dropCol = dropCol.replace(/ /g,'-');
					$('#coldrop_silver_preview .img-' + n).attr('src','//cdn.shopify.com/s/files/1/0297/8971/6528/files/cd-' + dropCol + '-' + n + '.png?');
				}
			}
	    });
	    // Preload img to speed things up.
	    var sgArray 	= ['azure-blue','clockwork-orange','crocus-purple','lovebird-green','mermaid-jade','sea-mist-mint','sunshine-yellow','surfs-up-blue','unicorn-white','flamingo'];
	    $.each(sgArray,function(i,val){
			for (var n = 1; n < 5; ++n) {
				$('head').append('<link rel="preload" as="image" href="//cdn.shopify.com/s/files/1/0297/8971/6528/files/cd-' + val + '-' + n + '.png?">');
			}
		});
    }
	
	// HALLOWEEN POP PREVIEW ============================== //
	if($('#halpop_preview').length != 0) {
		var thisSwatch 	= '';
		var pebCol 	    = '';
        var silkCol     = '';
		
		$('.bold_option_value_element').mouseup(function() {												// Using mouseup as click conflicts with Bold script, I think!
			thisSwatch = $(this).closest('.bold_option_swatch').find('.bold_option_title').text(); 			// Find title of swatch we're working with.
			if (thisSwatch === '1st Necklace - pick your pebble*') {
				pebCol = $(this).find('input[type="checkbox"]').attr('value').toLowerCase();
				pebCol = pebCol.replace(/ /g,'-');
				$('#halpop_preview img').attr('src','//cdn.shopify.com/s/files/1/0297/8971/6528/files/cp-sg-' + pebCol + '.png?');
			}
			if (thisSwatch === '1st Necklace - choose your cord colour*') {
				silkCol = $(this).find('input[type="checkbox"]').attr('value').toLowerCase();
				silkCol = silkCol.replace(/ /g,'-');
				$('#halpop_preview').attr('style','background-image: url(\'//cdn.shopify.com/s/files/1/0297/8971/6528/files/cp-silk-' + silkCol + '.jpg?\');');
			}
	    });
	    // Preload img to speed things up.
	    var sgArray 	= ['deep-black-pebble','knifophia'];
	    $.each(sgArray,function(i,val){
			$('head').append('<link rel="preload" as="image" href="//cdn.shopify.com/s/files/1/0297/8971/6528/files/cp-sg-' + val + '.png?">');
		});
	    var silkArray 	= ['black','orange'];
	    $.each(silkArray,function(i,val){
			$('head').append('<link rel="preload" as="image" href="//cdn.shopify.com/s/files/1/0297/8971/6528/files/cp-silk-' + val + '.jpg?">');
		});
    }
	    
	// BEAD PAIR PREVIEW ============================== //
	if($('#pair_preview').length != 0) {
		var thisSwatch 	= '';
		var pebCol 	= '';
		
		$('.bold_option_value_element').mouseup(function() {											// Using mouseup as click conflicts with Bold script, I think!
			thisSwatch = $(this).closest('.bold_option').find('.bold_option_title').text(); 			// Find title of swatch we're working with.
			if (thisSwatch === 'Choose Your Bead Colour*') {
				pebCol = $(this).find('input[type="checkbox"]').attr('value').toLowerCase();
				pebCol = pebCol.replace(/ /g,'-');
				//console.log(pebCol);
				$('#pair_preview .drop').attr('src','//cdn.shopify.com/s/files/1/0297/8971/6528/files/pair-' + pebCol + '.jpg?');
			}
	    });
	    // Preload img to speed things up.
	    var sgArray 	= ['apple-green','clear','dark-blue','grey','lavender','light-amber','mint','pale-blue','peach','rose','sea-glass-green','teal'];
	    $.each(sgArray,function(i,val){
			$('head').append('<link rel="preload" as="image" href="//cdn.shopify.com/s/files/1/0297/8971/6528/files/pair-' + val + '.jpg?">');
		});
	}
	    
	// SILVER POP PREVIEW ============================== //
	if($('#silpop_preview').length != 0) {
		var thisSwatch 	= '';
		var pebCol 	= '';
		
		$('.bold_option_value_element').mouseup(function() {												// Using mouseup as click conflicts with Bold script, I think!
			thisSwatch = $(this).closest('.bold_option_swatch').find('.bold_option_title').text(); 			// Find title of swatch we're working with.
			if (thisSwatch === 'Choose your pebble colour*') {
				pebCol = $(this).find('input[type="checkbox"]').attr('value').toLowerCase();
				pebCol = pebCol.replace(/ /g,'-');
				//console.log(pebCol);
				$('#silpop_preview img').attr('src','//cdn.shopify.com/s/files/1/0297/8971/6528/files/cp-sg-' + pebCol + '.png?');
			}
	    });
	    // Preload img to speed things up.
	    var sgArray 	= ['azure-blue','clockwork-orange','crocus-purple','lovebird-green','mermaid-jade','sea-mist-mint','sunshine-yellow','surfs-up-blue','unicorn-white','flamingo'];
	    $.each(sgArray,function(i,val){
			$('head').append('<link rel="preload" as="image" href="//cdn.shopify.com/s/files/1/0297/8971/6528/files/cp-sg-' + val + '.png?">');
		});
    }
	    
	// BEACH DROPS SILK PREVIEW ============================== //
	if($('#bd_preview').length != 0) {
		var thisSwatch 	= '';
		var pebCol 	    = '';
        var silkCol     = '';
		
		$('.bold_option_value_element').mouseup(function() {												// Using mouseup as click conflicts with Bold script, I think!
			thisSwatch = $(this).closest('.bold_option_swatch').find('.bold_option_title').text(); 			// Find title of swatch we're working with.
			if (thisSwatch === 'Choose 1st bead colour*') {
				pebCol = $(this).find('input[type="checkbox"]').attr('value').toLowerCase();
				pebCol = pebCol.replace(/ /g,'-');
				//console.log(pebCol);
				$('#bd_preview .img-l').attr('src','//cdn.shopify.com/s/files/1/0297/8971/6528/files/bd-l-' + pebCol + '.png?');
			}
			if (thisSwatch === 'Choose 2nd bead colour*') {
				pebCol = $(this).find('input[type="checkbox"]').attr('value').toLowerCase();
				pebCol = pebCol.replace(/ /g,'-');
				//console.log(pebCol);
				$('#bd_preview .img-c').attr('src','//cdn.shopify.com/s/files/1/0297/8971/6528/files/bd-c-' + pebCol + '.png?');
			}
			if (thisSwatch === 'Choose 3rd bead colour*') {
				pebCol = $(this).find('input[type="checkbox"]').attr('value').toLowerCase();
				pebCol = pebCol.replace(/ /g,'-');
				//console.log(pebCol);
				$('#bd_preview .img-r').attr('src','//cdn.shopify.com/s/files/1/0297/8971/6528/files/bd-r-' + pebCol + '.png?');
			}
			if (thisSwatch === 'Choose Silk Colour*') {
				silkCol = $(this).find('input[type="checkbox"]').attr('value').toLowerCase();
				silkCol = silkCol.replace(/ /g,'-');
				$('#bd_preview').attr('style','background-image: url(\'//cdn.shopify.com/s/files/1/0297/8971/6528/files/cp-silk-' + silkCol + '.jpg?\');');
			}
	    });
	    // Preload img to speed things up.
	    var sgArray 	= ['apple-green','clear','dark-blue','grey','lavender','light-amber','mint','pale-blue','peach','rose','sea-glass-green','teal'];
	    $.each(sgArray,function(i,val){
			$('head').append('<link rel="preload" as="image" href="//cdn.shopify.com/s/files/1/0297/8971/6528/files/bd-l-' + val + '.png?">');
			$('head').append('<link rel="preload" as="image" href="//cdn.shopify.com/s/files/1/0297/8971/6528/files/bd-c-' + val + '.png?">');
			$('head').append('<link rel="preload" as="image" href="//cdn.shopify.com/s/files/1/0297/8971/6528/files/bd-r-' + val + '.png?">');
		});
	    var silkArray 	= ['black','blue','dark-green','grey','light-green','lilac','orange','pink','purple','red','turquoise','yellow'];
	    $.each(silkArray,function(i,val){
			$('head').append('<link rel="preload" as="image" href="//cdn.shopify.com/s/files/1/0297/8971/6528/files/cp-silk-' + val + '.jpg?">');
		});
	}
	    
	// COLOUR DROP HOOP PREVIEW ============================== //
	if($('#cdh_preview').length != 0) {
		var thisSwatch 	= '';
		var dropCol 	= '';
		
		$('.bold_option_value_element').mouseup(function() {												// Using mouseup as click conflicts with Bold script, I think!
			thisSwatch = $(this).closest('.bold_option_swatch').find('.bold_option_title').text(); 			// Find title of swatch we're working with.
			if (thisSwatch === 'Choose Drop 1*') {
				dropCol = $(this).find('input[type="checkbox"]').attr('value').toLowerCase();
				dropCol = dropCol.replace(/ /g,'-');
				//console.log(dropCol);
				$('#cdh_preview .img-l').attr('src','//cdn.shopify.com/s/files/1/0297/8971/6528/files/cdh-' + dropCol + '-l.png?');
			}
			if (thisSwatch === 'Drop 2*') {
				dropCol = $(this).find('input[type="checkbox"]').attr('value').toLowerCase();
				dropCol = dropCol.replace(/ /g,'-');
				//console.log(dropCol);
				$('#cdh_preview .img-c').attr('src','//cdn.shopify.com/s/files/1/0297/8971/6528/files/cdh-' + dropCol + '-c.png?');
			}
			if (thisSwatch === 'Drop 3*') {
				dropCol = $(this).find('input[type="checkbox"]').attr('value').toLowerCase();
				dropCol = dropCol.replace(/ /g,'-');
				//console.log(dropCol);
				$('#cdh_preview .img-r').attr('src','//cdn.shopify.com/s/files/1/0297/8971/6528/files/cdh-' + dropCol + '-r.png?');
			}
	    });
	    // Preload img to speed things up.
	   var sgArray 	= ['azure-blue','clockwork-orange','crocus-purple','lovebird-green','mermaid-jade','sea-mist-mint','sunshine-yellow','surfs-up-blue','unicorn-white','flamingo','aloha','blush-pink','bright-red','bright-yellow','celedon','cola','coral','dirty-martini','egg-plant','electic-avenue','eventide','ginger','grass','heffalump','lava','minty','moana','mustard','poison-apple','ra','sand','sea-green','tamarind','tangerine','teal','toothpaste','urchin','white'];
	    $.each(sgArray,function(i,val){
			$('head').append('<link rel="preload" as="image" href="//cdn.shopify.com/s/files/1/0297/8971/6528/files/cdh-' + val + '-l.png?">');
			$('head').append('<link rel="preload" as="image" href="//cdn.shopify.com/s/files/1/0297/8971/6528/files/cdh-' + val + '-c.png?">');
			$('head').append('<link rel="preload" as="image" href="//cdn.shopify.com/s/files/1/0297/8971/6528/files/cdh-' + val + '-r.png?">');
		});
	}
	    
	// EAR HOOP PREVIEW ============================== //
	if($('#hoop_preview').length != 0) {
		var thisSwatch 	= '';
		var pebCol		= '';
		var hoopSize	= '';
		
		$('.bold_option_value').mouseup(function() {												// Using mouseup as click conflicts with Bold script, I think!
			thisSwatch = $(this).closest('.bold_option').find('.bold_option_title').text(); 			// Find title of swatch we're working with.
			if (thisSwatch === 'Choose Your Bead Colour*') {
				pebCol = $(this).find('input[type="checkbox"]').attr('value').toLowerCase();
				pebCol = pebCol.replace(/ /g,'-');
				//console.log(pebCol);
                $('#hoop_preview .drop').attr('src','//cdn.shopify.com/s/files/1/0297/8971/6528/files/ear-hoop-' + pebCol + '.png?');
			}
			if (thisSwatch === 'Choose Your Hoop Size*') {
				hoopSize = $(this).find('input[type="radio"]').attr('value').toLowerCase();
				hoopSize = hoopSize.replace(/ /g,'-');
                $('#hoop_preview').attr('style','background-image: url(\'//cdn.shopify.com/s/files/1/0297/8971/6528/files/ear-hoop-bg-' + hoopSize + '.jpg?\');');
                if ($('#hoop_preview').hasClass('gold')) {
    				$('#hoop_preview').attr('style','background-image: url(\'//cdn.shopify.com/s/files/1/0297/8971/6528/files/ear-hoop-bg-gold-' + hoopSize + '.jpg?\');');
                } else {
    				$('#hoop_preview').attr('style','background-image: url(\'//cdn.shopify.com/s/files/1/0297/8971/6528/files/ear-hoop-bg-' + hoopSize + '.jpg?\');');
                }
			}
	    });
	    // Preload img to speed things up.
	    var sgArray 	= ['apple-green','clear','dark-blue','grey','lavender','light-amber','mint','pale-blue','peach','rose','sea-glass-green','teal','bright-green'];
	    $.each(sgArray,function(i,val){
			$('head').append('<link rel="preload" as="image" href="//cdn.shopify.com/s/files/1/0297/8971/6528/files/ear-hoop-' + val + '.png?">');
		});
		$('head').append('<link rel="preload" as="image" href="//cdn.shopify.com/s/files/1/0297/8971/6528/files/ear-hoop-bg-large-30mm.jpg?">');
		$('head').append('<link rel="preload" as="image" href="//cdn.shopify.com/s/files/1/0297/8971/6528/files/ear-hoop-bg-small-20mm.jpg?">');
		$('head').append('<link rel="preload" as="image" href="//cdn.shopify.com/s/files/1/0297/8971/6528/files/ear-hoop-bg-gold-large-30mm.jpg?">');
		$('head').append('<link rel="preload" as="image" href="//cdn.shopify.com/s/files/1/0297/8971/6528/files/ear-hoop-bg-gold-small-20mm.jpg?">');
	}
	    
	// PEBBLE CHAIN PREVIEW ============================== //
	if($('#pebble_preview').length != 0) {
		//console.log('pebble_preview');
		var thisSwatch 	= '';
		var pebCol		= '';
		
		$('.bold_option_value').mouseup(function() {
			thisSwatch = $(this).closest('.bold_option').find('.bold_option_title').text();
			if (thisSwatch === 'Choose your glass pebble*') {
				pebCol = $(this).find('input[type="checkbox"]').attr('value').toLowerCase();
				pebCol = pebCol.replace(/ /g,'-');
				//console.log(pebCol);
                $('#pebble_preview img').attr('src','//cdn.shopify.com/s/files/1/0297/8971/6528/files/pebble-' + pebCol + '.png?');
			}
	    });
	    // Preload img to speed things up.
	    var pebArray 	= ['amber','apple-green','baby-blue','berry','clear','dark-blue','dark-pink','emerald','grey','lavender','light-pink','sea-glass-green'];
	    $.each(pebArray,function(i,val){
			$('head').append('<link rel="preload" as="image" href="//cdn.shopify.com/s/files/1/0297/8971/6528/files/pebble-' + val + '.png?">');
		});
	}
	    
	// EAR CHAIN PREVIEW ============================== //
	if($('#chain_preview').length != 0) {
		var thisSwatch 	= '';
		var pebCol 	= '';
		
		$('.bold_option_value_element').mouseup(function() {												// Using mouseup as click conflicts with Bold script, I think!
			thisSwatch = $(this).closest('.bold_option').find('.bold_option_title').text(); 			// Find title of swatch we're working with.
			if (thisSwatch === 'Choose Your Bead Colour*') {
				pebCol = $(this).find('input[type="checkbox"]').attr('value').toLowerCase();
				pebCol = pebCol.replace(/ /g,'-');
				//console.log(pebCol);
				$('#chain_preview .drop').attr('src','//cdn.shopify.com/s/files/1/0297/8971/6528/files/ear-chain-' + pebCol + '.png?');
			}
	    });
	    // Preload img to speed things up.
	    var sgArray 	= ['apple-green','clear','dark-blue','grey','lavender','light-amber','mint','pale-blue','peach','rose','sea-glass-green','teal','bright-green'];
	    $.each(sgArray,function(i,val){
			$('head').append('<link rel="preload" as="image" href="//cdn.shopify.com/s/files/1/0297/8971/6528/files/ear-chain-' + val + '.png?">');
		});
	}
	    
	// BEACH DROPS SILVER PREVIEW ============================== //
	if($('#bd_preview_silver').length != 0) {
		var thisSwatch 	= '';
		var pebCol 	= '';
		
		$('.bold_option_value_element').mouseup(function() {												// Using mouseup as click conflicts with Bold script, I think!
			thisSwatch = $(this).closest('.bold_option_swatch').find('.bold_option_title').text(); 			// Find title of swatch we're working with.
			if (thisSwatch === 'Choose 1st bead colour*') {
				pebCol = $(this).find('input[type="checkbox"]').attr('value').toLowerCase();
				pebCol = pebCol.replace(/ /g,'-');
				//console.log(pebCol);
				$('#bd_preview_silver .img-l').attr('src','//cdn.shopify.com/s/files/1/0297/8971/6528/files/bd-l-' + pebCol + '.png?');
			}
			if (thisSwatch === 'Choose 2nd bead colour*') {
				pebCol = $(this).find('input[type="checkbox"]').attr('value').toLowerCase();
				pebCol = pebCol.replace(/ /g,'-');
				//console.log(pebCol);
				$('#bd_preview_silver .img-c').attr('src','//cdn.shopify.com/s/files/1/0297/8971/6528/files/bd-c-' + pebCol + '.png?');
			}
			if (thisSwatch === 'Choose 3rd bead colour*') {
				pebCol = $(this).find('input[type="checkbox"]').attr('value').toLowerCase();
				pebCol = pebCol.replace(/ /g,'-');
				//console.log(pebCol);
				$('#bd_preview_silver .img-r').attr('src','//cdn.shopify.com/s/files/1/0297/8971/6528/files/bd-r-' + pebCol + '.png?');
			}
	    });
	    // Preload img to speed things up.
	    var sgArray 	= ['apple-green','clear','dark-blue','grey','lavender','light-amber','mint','pale-blue','peach','rose','sea-glass-green','teal'];
	    $.each(sgArray,function(i,val){
			$('head').append('<link rel="preload" as="image" href="//cdn.shopify.com/s/files/1/0297/8971/6528/files/bd-l-' + val + '.png?">');
			$('head').append('<link rel="preload" as="image" href="//cdn.shopify.com/s/files/1/0297/8971/6528/files/bd-c-' + val + '.png?">');
			$('head').append('<link rel="preload" as="image" href="//cdn.shopify.com/s/files/1/0297/8971/6528/files/bd-r-' + val + '.png?">');
		});
    }
	    
	// BEACH DROPS GOLD PREVIEW ============================== //
	if($('#bd_preview_gold').length != 0) {
		var thisSwatch 	= '';
		var pebCol 	= '';
		
		$('.bold_option_value_element').mouseup(function() {												// Using mouseup as click conflicts with Bold script, I think!
			thisSwatch = $(this).closest('.bold_option_swatch').find('.bold_option_title').text(); 			// Find title of swatch we're working with.
			if (thisSwatch === 'Choose 1st bead colour*') {
				pebCol = $(this).find('input[type="checkbox"]').attr('value').toLowerCase();
				pebCol = pebCol.replace(/ /g,'-');
				//console.log(pebCol);
				$('#bd_preview_gold .img-l').attr('src','//cdn.shopify.com/s/files/1/0297/8971/6528/files/bd-l-' + pebCol + '.png?');
			}
			if (thisSwatch === 'Choose 2nd bead colour*') {
				pebCol = $(this).find('input[type="checkbox"]').attr('value').toLowerCase();
				pebCol = pebCol.replace(/ /g,'-');
				//console.log(pebCol);
				$('#bd_preview_gold .img-c').attr('src','//cdn.shopify.com/s/files/1/0297/8971/6528/files/bd-c-' + pebCol + '.png?');
			}
			if (thisSwatch === 'Choose 3rd bead colour*') {
				pebCol = $(this).find('input[type="checkbox"]').attr('value').toLowerCase();
				pebCol = pebCol.replace(/ /g,'-');
				//console.log(pebCol);
				$('#bd_preview_gold .img-r').attr('src','//cdn.shopify.com/s/files/1/0297/8971/6528/files/bd-r-' + pebCol + '.png?');
			}
	    });
	    // Preload img to speed things up.
	    var sgArray 	= ['apple-green','clear','dark-blue','grey','lavender','light-amber','mint','pale-blue','peach','rose','sea-glass-green','teal'];
	    $.each(sgArray,function(i,val){
			$('head').append('<link rel="preload" as="image" href="//cdn.shopify.com/s/files/1/0297/8971/6528/files/bd-l-' + val + '.png?">');
			$('head').append('<link rel="preload" as="image" href="//cdn.shopify.com/s/files/1/0297/8971/6528/files/bd-c-' + val + '.png?">');
			$('head').append('<link rel="preload" as="image" href="//cdn.shopify.com/s/files/1/0297/8971/6528/files/bd-r-' + val + '.png?">');
		});
    }
	    
	// CHARITY CORD PREVIEW 06/11/24 ============================== //
	if($('#charbrac_preview').length != 0) {
		var thisSwatch 	= '';
        var cordCol     = '';
		
		$('.bold_option_value_element').mouseup(function() {												// Using mouseup as click conflicts with Bold script, I think!
			thisSwatch = $(this).closest('.bold_option_swatch').find('.bold_option_title').text(); 			// Find title of swatch we're working with.
			if (thisSwatch === 'Choose your bracelet colour*') {
				cordCol = $(this).find('input[type="checkbox"]').attr('value').toLowerCase();
				cordCol = cordCol.replace(/ /g,'-');
				cordCol = cordCol.replace('-cord','');
				$('#charbrac_preview').attr('style','background-image: url(\'//cdn.shopify.com/s/files/1/0297/8971/6528/files/cord-' + cordCol + '.jpg\');');
			}
			$('#charbrac_preview').removeClass('hide');
	    });
	    // Preload img to speed things up.
	    var cordArray 	= ['black','brown','coral','light-grey','mango','mint','red','sand','sea-green','sky-blue','teal','thistle'];
	    $.each(cordArray,function(i,val){
			$('head').append('<link rel="preload" as="image" href="//cdn.shopify.com/s/files/1/0297/8971/6528/files/cord-' + val + '.jpg">');
		});
    }
});